import { Table, TableHead, TableRow, TableHeader, TableBody, TableCell } from "../../Catalyst/table";
import { Button } from "../../Catalyst/button";
import { Badge } from "../../Catalyst/badge";
import { NotificationItem } from "../../../store/slices/NotificationsSlice";
import { NOTIFICATION_STATUS_BADGE } from "../../../constants/notifications";
import { formatDateTime, getNotificationType, getNotificationUserName } from "./utils";

interface NotificationsTableProps {
  notifications: NotificationItem[];
  onViewDetails: (notification: NotificationItem) => void;
}

const NotificationsTable = ({ notifications, onViewDetails }: NotificationsTableProps) => {
  return (
    <Table>
      <TableHead>
        <TableRow className="bg-[#F9FAFB] border border-x-[#EAECF0]">
          <TableHeader>User</TableHeader>
          <TableHeader>Type</TableHeader>
          <TableHeader>Status</TableHeader>
          <TableHeader>Channel</TableHeader>
          <TableHeader>Created</TableHeader>
          <TableHeader>Sent</TableHeader>
          <TableHeader className="text-right">Actions</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {notifications.map((notification) => {
          const statusConfig = NOTIFICATION_STATUS_BADGE[notification.status];
          return (
            <TableRow key={notification.insightId}>
              <TableCell className="font-medium text-texthead">
                {getNotificationUserName(notification)}
              </TableCell>
              <TableCell>
                <div className="flex flex-col">
                  <span className="font-medium text-texthead">
                    {getNotificationType(notification)}
                  </span>
                  {notification.ruleName && (
                    <span className="text-xs text-zinc-500">{notification.ruleName}</span>
                  )}
                </div>
              </TableCell>
              <TableCell>
                <Badge color={statusConfig?.color ?? "zinc"}>
                  {statusConfig?.label ?? notification.status}
                </Badge>
              </TableCell>
              <TableCell className="text-textColor">{notification.channel || "—"}</TableCell>
              <TableCell className="text-textColor">{formatDateTime(notification.createdAt)}</TableCell>
              <TableCell className="text-textColor">{formatDateTime(notification.sentAt)}</TableCell>
              <TableCell className="text-right">
                <Button outline onClick={() => onViewDetails(notification)}>
                  <span className="desktext13">View details</span>
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default NotificationsTable;
